import { render, staticRenderFns } from "./CodeMirrorWrapper.vue?vue&type=template&id=bcafe69c&"
import script from "./CodeMirrorWrapper.vue?vue&type=script&lang=ts&"
export * from "./CodeMirrorWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CodeMirrorWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports